import { Fragment, ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CallId, VideoCallRejectEvent } from 'shared/models';
import { useSelector } from 'react-redux';
import { State } from 'reducers';
import { getVideoCall } from 'selectors/ecsSelectors';
import { getUser } from 'selectors/usersSelectors';

export type Props = {
    callId?: CallId;
    details: VideoCallRejectEvent['details'];
};

export const RejectEventDetails = (props: Props) => {
    const { t } = useTranslation();
    const { reason } = props.details;

    const videoCall = useSelector((state: State) => getVideoCall(state, props));
    const userId = (videoCall && videoCall.userId) || undefined;
    const user = useSelector((state: State) => videoCall && getUser(state, { userId }));
    const userName = user && (user.displayName || user.emailAddress);

    const nodes = useMemo<ReactNode>(() => {
        const template = t(`VIDEO.EVENT.RJCT_${reason}_DETAIL`);
        const parts: ReactNode[] = [];
        template.replace(/([^<]*)(?:<([^>]+)\/>)?/g, (match, text: string, tag: string) => {
            if (text) {
                parts.push(
                    <span key={ parts.length.toString() }>
                        { text }
                    </span>
                );
            }
            if (tag === 'USER' && userName) {
                parts.push(
                    <b key={ userName }>
                        { userName }
                    </b>
                );
            }
            return '';
        });
        return parts;
    }, [ userName, reason, t ]);

    return (
        <Fragment>
            { nodes }
        </Fragment>
    );
};
